<div class="text-center" [hidden]="!showIndicator">
  <div class="lds-ellipsis-mint">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>